import { ALAppHeaderComponent } from './al-app-header/al-app-header.component';
import { ALNavHeaderComponent } from './al-nav-header/al-nav-header.component';
import { ALSideNavComponent } from './al-sidenav/al-sidenav.component';
import { AlHighchartColumnComponent } from './al-highchart-column/al-highchart-column.component';
import { AlHighchartSemiCircleComponent } from './al-highchart-semi-circle/al-highchart-semi-circle.component';
import { AlHighchartTreeMapComponent } from './al-highchart-treemap/al-highchart-treemap.component';
import { AlDetailedTableListComponent } from './al-detailed-table-list/al-detailed-table-list.component';
import { AlDashboardWidgetComponent } from './al-dashboard-widget/al-dashboard-widget.component';
import { AlHighchartsActivityGaugeComponent } from './al-highchart-activity-gauge/al-highchart-activity-gauge.component';
import { AlDashboardLayoutComponent } from './al-dashboard-layout/al-dashboard-layout.component';
import { AlDropdownFilterComponent } from './al-dropdown-filter/al-dropdown-filter.component';
import { AlCountSummaryComponent } from './al-count-summary/al-count-summary.component';
import { AlHighchartAreaGraphComponent } from './al-highchart-area-graph/al-highchart-area-graph.component';
import { AlHighchartBarComponent } from './al-highchart-bar/al-highchart-bar.component';

const ALL_COMPONENTS = [
  AlHighchartColumnComponent,
  AlHighchartSemiCircleComponent,
  AlHighchartTreeMapComponent,
  AlDetailedTableListComponent,
  AlDashboardWidgetComponent,
  ALAppHeaderComponent,
  ALNavHeaderComponent,
  ALSideNavComponent,
  AlHighchartsActivityGaugeComponent,
  AlDashboardLayoutComponent,
  AlDropdownFilterComponent,
  AlCountSummaryComponent,
  AlHighchartAreaGraphComponent,
  AlHighchartBarComponent
];

export {
  ALL_COMPONENTS
};
